import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-22e82dd0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "background",
  style: {"background-image":"url('assets/start/fondo-inicio.jpg')"}
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "txtSegSlogan" }, [
  /*#__PURE__*/_createTextVNode("Controla tu"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" canal musical")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_ion_grid, { class: "mainGrid" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, { class: "topRowImage ion-justify-content-center ion-align-items-end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    size: "12",
                    style: {"text-align":"center"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_img, {
                        src: "assets/ICONOS/vybroo-logo-sa.png",
                        id: "imgLogoInicio"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "botRowDiv ion-justify-content-center ion-align-items-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    size: "12",
                    style: {"text-align":"center"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_img, {
                        src: "assets/start/categoria-musical-blanco.png",
                        id: "imgCatMus"
                      }),
                      _hoisted_2,
                      _createVNode(_component_ion_button, {
                        id: "loginButton",
                        fill: "solid",
                        style: {"text-transform":"none","font-weight":"600"},
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (this.$router.push('/login/LoginUser')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Inicia sesión")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}